<template>
  <div>{{ ingredient.amount }} {{ ingredient.measure }} {{ ingredient.name }} {{ ingredient.prep ? ", " + ingredient.prep : "" }}</div>
</template>

<script>
export default {
  name: "recipe-ingredient",
  props: ["ingredient"]
};
</script>